module.exports = __webpack_public_path__ + "media/images/icons/benefits_work_with_pros-855d12cd9ffe28f885dbe71e71de00a7.svg";